import React from 'react';
import { useNavigate } from 'react-router-dom';
import { markNotificationAsRead } from '../../services/notificationService';
import Button from '../common/Button';
import { Caption, Typography } from '../common/Typography';
import CollapsibleNotificationItem from '../notifications/CollapsibleNotificationItem';

/**
 * ClubJoinRequestNotificationItem Component
 * Notification item for club join requests with link to join request management
 */
const ClubJoinRequestNotificationItem = ({ 
  notification, 
  currentUser,
  onUpdate,
  onClose 
}) => {
  const navigate = useNavigate();
  const notificationData = notification.data || {};
  const clubId = notificationData.club_id;
  const clubName = notificationData.club_name || 'the club';
  const playerName = notificationData.player_name || 'A player';
  const requestId = notificationData.request_id;

  const handleGoToJoinRequests = async () => {
    // Mark notification as read
    if (notification.id && !notification.is_read) {
      try {
        await markNotificationAsRead(notification.id);
      } catch (err) {
        console.error('Error marking notification as read:', err);
      }
    }

    // Close notifications modal
    if (onClose) {
      onClose();
    }

    // Navigate to club admin page (join requests are shown in Player Management)
    if (clubId) {
      navigate(`/club/${clubId}/settings`, {
        state: {
          activeTab: 'player-management',
          selectedClub: { id: clubId }
        }
      });
    }

    // Update notifications list
    if (onUpdate) {
      onUpdate();
    }
  };

  const detailsContent = (
    <>
      <div className="text-sm">
        <span className="text-text-muted">Player: </span>
        <Typography variant="strong" as="span">{playerName}</Typography>
      </div>
    </>
  );

  const metadata = clubName && (
    <Caption>Club: {clubName}</Caption>
  );

  return (
    <CollapsibleNotificationItem
      notification={notification}
      borderColor="blue"
      badgeVariant="info"
      detailsContent={detailsContent}
      metadata={metadata}
    >
      <Button
        variant="primary"
        size="small"
        onClick={handleGoToJoinRequests}
      >
        Review Join Request
      </Button>
    </CollapsibleNotificationItem>
  );
};

export default ClubJoinRequestNotificationItem;

